export default "__VITE_ASSET__744224c4__"